import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { FiStar } from "react-icons/fi";
import { TESTIMONIALS } from "../utils/siteData";
import api, { imgUrl } from "../utils/api";

function initials(name = "") {
  return name
    .replace(/^(mr\.|mrs\.|ms\.)/i, "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

// Normalise a DB testimonial so it renders the same as the static ones
const shape = (t) => ({
  name: t.name,
  location: t.location || "",
  text: t.text,
  image: t.image || "",
  rating: t.rating || 5,
});

export default function TestimonialCarousel() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/testimonials")
      .then((res) => setItems((res.data || []).map(shape)))
      // Silently fall back to static testimonials if the API is unavailable
      .catch(() => setItems(TESTIMONIALS.map((t) => ({ ...t, image: "", rating: 5 }))));
  }, []);

  if (items.length === 0) return null;

  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 5000, disableOnInteraction: false }}
      pagination={{ clickable: true }}
      spaceBetween={24}
      slidesPerView={1}
      breakpoints={{
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 },
      }}
      className="pb-12"
    >
      {items.map((t, i) => (
        <SwiperSlide key={i}>
          <div className="relative bg-white rounded-2xl p-7 shadow-premium border border-gold-100 hover-lift h-full overflow-hidden">
            {/* big decorative quote mark */}
            <span className="absolute -top-2 right-4 font-heading text-7xl text-gold-200 select-none pointer-events-none">
              &rdquo;
            </span>
            <div className="flex gap-1 text-gold-500 mb-3 drop-shadow-sm">
              {[...Array(5)].map((_, idx) => (
                <FiStar
                  key={idx}
                  size={15}
                  fill={idx < t.rating ? "currentColor" : "none"}
                  className={idx < t.rating ? "" : "text-gold-200"}
                />
              ))}
            </div>
            <p className="text-gray-700 italic leading-relaxed mb-5 relative z-10">“{t.text}”</p>
            <div className="flex items-center gap-3 relative z-10">
              {t.image ? (
                <img
                  src={imgUrl(t.image)}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover border border-gold-200"
                />
              ) : (
                <div className="w-11 h-11 rounded-full bg-maroon-gradient text-gold-200 flex items-center justify-center font-heading text-sm shadow-gold ring-1 ring-gold-300/30">
                  {initials(t.name)}
                </div>
              )}
              <div>
                <p className="font-heading text-maroon-800 leading-tight">{t.name}</p>
                <p className="text-sm text-saffron-600">{t.location}</p>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
